import { ApiTransformedAttachment } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { MIME_TO_EXTENSION } from '../../constants';
import { ApiAttachment } from '../types';

const getExtensionFromType = (type: string | null | undefined): string => {
    if (!type) return '';

    return MIME_TO_EXTENSION[type] || type.split('/').pop() || '';
};

const getFileNameFromUrl = (downloadUrl: string | null | undefined): string => {
    if (!downloadUrl) return '';

    try {
        const url = new URL(downloadUrl);
        const pathParts = url.pathname.split('/');
        const lastPart = pathParts[pathParts.length - 1];

        return decodeURIComponent(lastPart.split('?')[0]) || '';
    } catch {
        return '';
    }
};

const findPreviewUrl = (
    previewUrls: ApiAttachment['previewUrls'] | null | undefined,
    transformation: Gql.AttachmentPreviewTransformation
): string | undefined => {
    if (!previewUrls?.length) return undefined;

    return previewUrls.find((p) => p.transformation === transformation)?.url ?? undefined;
};

export const transformApiAttachmentToFileAttachment = (apiAttachment: ApiAttachment): ApiTransformedAttachment => {
    const extension = getExtensionFromType(apiAttachment.type);
    const fileName = getFileNameFromUrl(apiAttachment.downloadUrl);

    const originalUrl = findPreviewUrl(apiAttachment.previewUrls, Gql.AttachmentPreviewTransformation.None);
    const mediumPreviewUrl = findPreviewUrl(
        apiAttachment.previewUrls,
        Gql.AttachmentPreviewTransformation.BriefMediumPreview
    );

    const coverImageUrl = mediumPreviewUrl || originalUrl;

    return {
        id: apiAttachment.id,
        pending_attachment_id: apiAttachment.id,
        type: apiAttachment.type || '',
        fileName,
        name: fileName,
        extension,
        loaded: true,
        sortId: apiAttachment.id,
        fileSize: '',
        size: 0,
        download_url: apiAttachment.downloadUrl ?? undefined,
        open_url: apiAttachment.pdfOpenUrl,
        coverImageUrl,
        preview_urls: {
            original: originalUrl,
            thumb_large: mediumPreviewUrl || originalUrl,
            large: originalUrl,
        },
    };
};
